const origin = location.origin === 'http://localhost:4200' ? 'http://analytics' : location.origin;
let apiURL = origin + '/backend';

export const API_BASE_URL = apiURL;
export const RESPONSE_CODE_OK = 200;
export const RESPONSE_CODE_ERROR = 500;